export const tableContainerSx = {
  maxWidth: 400,
  width: '100%',
  '.MuiTableCell-root': {
    fontSize: '14px',
  },
};

export const tableRowSx = (theme) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.background.secondary,
  },
});

export const tableIconBtnSx = { padding: 0 };

export const tablePaginationSx = (color) => ({
  color,
  '.MuiTablePagination-toolbar': {
    fontSize: '14px',
  },
  '.MuiTablePagination-select': {
    fontSize: '14px',
  },
  '.MuiTablePagination-selectIcon': {
    color,
  },
  '.MuiTablePagination-selectLabel': {
    fontSize: '14px',
  },
  '.MuiTablePagination-displayedRows': {
    fontSize: '14px',
  },
});
